import createIcon from '../../createIcon';

/**
 * @component @name Delete
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNiAxOUM2IDIwLjEgNi45IDIxIDggMjFIMTZDMTcuMSAyMSAxOCAyMC4xIDE4IDE5VjdINlYxOVpNMTkgNEgxNS41TDE0LjUgM0g5LjVMOC41IDRINVY2SDE5VjRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Delete = createIcon('Delete', [
  [
    'path',
    {
      d: 'M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM19 4H15.5L14.5 3H9.5L8.5 4H5V6H19V4Z',
      key: 'hh9yod',
    },
  ],
]);

export default Delete;
